import type { Release } from '../releases';

export default {
  id: '2026-11-04-split-approval-limit',
  at: '2026-11-04T10:23:00Z',
  title: 'Дробление закупки под лимит согласования видно согласующему',
  modules: ['procurement', 'contracts'],
  items: [
    'Если у согласующего есть лимит по сумме, карточка заявки на закуп и карточка договора показывают сходные закупки того же поставщика за окно проверки: каждая в пределах его лимита, а вместе выше.',
    'Строка блока «Возможное дробление закупки» подписана «при вашем лимите», рядом ссылки на сходные договоры и заявки. Суммы видны только с уровнем денег.',
  ],
  why: 'Закупку можно было разбить на части, каждая из которых проходит у одного согласующего, хотя целиком её решал бы следующий. Теперь согласующий видит это до решения.',
  link: '/procurement',
} satisfies Release;
